import { MenuItem, Select } from "@material-ui/core";
import Moment from "moment-timezone";
import { default as React, useEffect, useReducer, useState } from "react";
import translate from "../../../i18n/translate";
import { ICalendarEvent, IFeedbackData, ILearnerSessions, ISessionRating, IUpcomingData } from "../../../interfaces";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import Loader from "../../shared/Loader/Loader";
import SessionRatingPopup from "../../shared/SessionRatingPopup/SessionRatingPopup";
import Toaster from "../../shared/Toaster/Toaster";
import getElevateMockSessionsData from "../../../data/MockData/getElevateTMSlearnerSessions.json"
import "./MyScheduleSummaryBlock.scss";
import { useSelector, useDispatch } from "react-redux";
import allActions from "../../../redux/actions";
import LatestUpcomingBlock from "./LatestUpcomingBlock";
import AllSessionBlock from "./AllSessionBlock";
import { getCoursesByStatus } from "./MySchedulePageUtils";
import { getStudentStatus } from "../ProgressDetailsPage/SubComponent/utils";

const PastAndUpcomingSessions = (props: any) => {
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const [productName, setProductName] = useState("")
  let response: any;
  // document.title = "Halo - Schedule"
  let [status, setstatus] = useState(0);

  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  }
  const handleCalendarClick = () => {
    const cal = require('ics');
    const modifiedEvents = calendarEvents.map(({uid, ...keepAttrs}) => keepAttrs);
    if (!cal) {
      const {value} = cal.createEvents([...modifiedEvents]);
      saveIcs(value, "LearnshipCalendar", "ics");
    }
  };
  function saveIcs(calendar: any, filename : string, ext : String) {
    let blob;
    const updatedCalendar : string = [calendar.slice(0, 15),"\nX-WR-CALNAME:Learnship", calendar.slice(15)].join('');
    if (navigator.userAgent.indexOf('MSIE 10') === -1) { // chrome or firefox
      blob = new Blob([updatedCalendar]);
    }
    const FileSaver = require('file-saver');
    FileSaver.saveAs(blob, filename + "." + ext);
    return updatedCalendar;
  }
  const handleDispatch = () => {
    const courseId: number = Number(sessionStorage.getItem("courseId")) || 0;
    if (!allInfo.createSessionService.isLoading) {
      dispatch(allActions.createSessionServiceAction.createSessionService(courseId));
    }
    if (allInfo.tmsLearnerSessions.isLoading) {
      dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
    }
  }

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", open);
  };
  let session_starttimeUTC: any;
  let session_endtimeUTC: any;
  let session_GetstartDate: any;
  let durationMins: number;
  let coachname: any;
  let sessionId: any;
  let startTime: any;
  let session_GetEndDate: any;
  let rescheduleDiffHours: any;
  let rescheduleSeatPoolHours: any;
  let rescheduleLimit: any;
  let sessionRescheduleCalculation: any;
  const [cancelledSessionCount, setcancelledSessionCount] = useState(0);
  let UpcomingArray: IUpcomingData[] = {} as IUpcomingData[];
  let UpcomingCounter: number = 0;
  let ClassCounter: number = 0;
  let allowReschedule: boolean = false;
  let allowCancellation: boolean = false;
  const upcomingSessionsData: ILearnerSessions[] = {} as ILearnerSessions[];
  const pastSessionsData: ILearnerSessions[] = {} as ILearnerSessions[];
  const FinishedSessionsData: ILearnerSessions[] = {} as ILearnerSessions[];
  const RecentUpcomingData: ILearnerSessions = {} as ILearnerSessions;
  const missedSessionData: any = {} as ILearnerSessions[];
  const [RecentData, SetRecentData] = useState({} as ILearnerSessions);
  const [UpcomingData, SetUpcomingData] = useState(upcomingSessionsData as ILearnerSessions[]);
  const [CompletedData, setCompletedData] = useState(upcomingSessionsData as ILearnerSessions[]);
  const [missedData, setMissedData] = useState(upcomingSessionsData as ILearnerSessions[])
  const [AllSessionData, SetAllSessionData] = useState({} as ILearnerSessions[]);
  let PastCounter: number = 0;
  let finishedCounter: number = 0;
  let missedCounter: number = 0;
  let momentDate : any;
  let momentEndDate : any;
  const [isJoinNowEnabled, setJoinNow] = useState(false);
  const [isCancelVisible, setcancelButton] = useState(false);
  const [currentSessionLink, setCurrentSessionLink] = useState("");
  const [records, setRecords] = React.useState("All sessions");
  const [sessionRatingProps, setSessionRating] = useState({} as ISessionRating);
  const [ratingPopup, setRatingPopup] = useState(false);
  const [duration, setDuration] = useState(0);
  const [comMode, setComMode] = useState("");
  const [loaderFlag, setLoaderFlag] = useState(true);
  const [calendarEvents, setCalenderEvents] =useState<ICalendarEvent[]>([]);
  const [isSprintSkillsGroups, setIsSprintSkillsGroups] = useState(false);
  const [uuid, setUuid] = useState(false);
  let addCalendarEvents = [] as ICalendarEvent[];

  let sessionNumber: number = 0;
  useEffect(() => {
    sessionStorage.setItem("RescheduleChkBox", "False");
  }, []);


  useEffect(() => {
    if (
      !allInfo.getLearnerFeedback.isLoading &&
      !allInfo.tmsLearnerSessions.isLoading &&
      !allInfo.peopleInformation.isLoading &&
      !allInfo.tmsCourses.isLoading &&
      !allInfo.common.isLoading
    ) {
      setLoaderFlag(false);
      if(allInfo.peopleInformation.data){
        const isGroups = allInfo.peopleInformation.data.getpeopleInformation.license.filter((product: any) => product.productId === "29");
        const prodName = allInfo.peopleInformation.data.getpeopleInformation.license.find((product: any) => product.productId == props.prodId).productName;
        setProductName(prodName);
        if(isGroups.length > 0){
          setIsSprintSkillsGroups(true);
        }
      }
      if(allInfo.common){
        setUuid(allInfo.common.luuId)
      }
    } else {
      setLoaderFlag(true);
    }
    if (allInfo.getLearnerFeedback.data && allInfo.tmsLearnerSessions.data && allInfo.peopleInformation.data && allInfo.common.luuId) {
      getSessionDetails();
    }
  }, [allInfo.tmsLearnerSessions, allInfo.learnerJWToken, allInfo.getLearnerFeedback, allInfo.peopleInformation, allInfo.common, allInfo.tmsCourses, isSprintSkillsGroups, uuid]);

  const getSessionDetails = () => {
    getLatestSessionDetails(allInfo.getLearnerFeedback.data);
  };
  const joinNowCheck = (startTime: any, classRoomLink: any) => {
    let joinNowDiffHours = (startTime - Moment().unix()) / 60;
    if (joinNowDiffHours <= 10) {
      setJoinNow(true);
      setCurrentSessionLink(classRoomLink);
    }
    if (joinNowDiffHours > 0) setcancelButton(true);
    if(Moment().unix() > startTime+600){
      setJoinNow(false);
    }
  };

  const handeRecords = (event: React.ChangeEvent<{ value: unknown }>) => {
    setRecords(event.target.value as string);
  };
  const getLatestSessionDetails = (feebackDetails: any) => {
    const canceledSessionCountCheck = (sessions: any) => {
      for (let i = 0; i < sessions.length; i++) {
        if (sessions[i].status === "canceled" || sessions[i].status === "lost") {
          setcancelledSessionCount(cancelledSessionCount + 1);
        }
      }
      return cancelledSessionCount;
    };
    response = allInfo.tmsLearnerSessions.data.getTMSLearnerSessions.slice().sort((a: any, b: any) => b.startTime - a.startTime).reverse();
    if(isSprintSkillsGroups){
    const newResponse = response.map((session: any) => {
        if(uuid){
          const newSession = {...session};
          const newStudentArray = newSession.students.filter((stud: any) => stud.guid === uuid);
          newSession.students = newStudentArray;
          return newSession;
        }
      })
    response = newResponse;
    }
    let tmsCourseDetails: any;
    if(allInfo.tmsCourses.data){
      tmsCourseDetails = allInfo.tmsCourses.data.getTMSGetCourse;
      if(tmsCourseDetails.length > 0) {
        let validCourses = getCoursesByStatus(tmsCourseDetails);
        response = response.filter((session: any) => {
          let foundSession = validCourses.find((course: any) => course.courseId === session.course);
          if(foundSession) {
            return foundSession;
          }
        });
      }
    }
    let courseId = parseInt(window.location.href.split("/")[4]);
    if(courseId === 95 && sessionStorage.getItem("isDemoUser")) {
      response = getElevateMockSessionsData.data.getTMSLearnerSessions.slice().sort((a: any, b: any) => b.startTime - a.startTime).reverse();
    }
    canceledSessionCountCheck(allInfo.tmsLearnerSessions.data);

    //To set duration for a single session
    let singleDuration: number = parseInt(process.env.REACT_APP_MAX_SESSION_HOURS || "0");
    setDuration(singleDuration);
    for (let i = 0; i < response.length; i++) {
      let sessionDuration: number = (parseInt(response[i].endTime) - parseInt(response[i].startTime)) / 60;
      if (sessionDuration < singleDuration && response[i].course === parseInt(window.location.href.split("/")[4])) {
        singleDuration = sessionDuration;

      }
      setDuration(singleDuration);
    }

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < response.length; i++) {
      // tslint:disable-next-line: prefer-for-of
      for (let j = 0; j < response[i].students.length; j++) {
        session_starttimeUTC = Moment.unix(parseInt(response[i].startTime)).format("hh:mm A");
        session_endtimeUTC = Moment.unix(parseInt(response[i].endTime)).format("hh:mm A");
        session_GetstartDate = Moment.unix(parseInt(response[i].startTime)).format("DD MMMM YYYY");
        session_GetEndDate = Moment.unix(parseInt(response[i].endTime)).format("DD MMMM YYYY");
        durationMins = (parseInt(response[i].endTime) - parseInt(response[i].startTime)) / 60;
        const studentsStatus = response[i].students.filter((res: any) => uuid == res.guid)[0]?.status;
        const studentsupdated = getStudentStatus(studentsStatus)
        if (response[0].sessionCalendarType === "onsite") {
          setComMode(response[i].sessionLocation);
        } else {
          setComMode("Virtual classroom");
        }
        coachname = response[i].teacher?.name?.replace(/,/g, "") ?? "";
        sessionId = response[i].id;
        momentDate = Moment(Moment.unix(parseInt(response[i].startTime)));
        momentEndDate= Moment(Moment.unix(parseInt(response[i].endTime)));
        startTime =
          session_starttimeUTC +
          " " +
            momentDate
            .tz(Moment.tz.guess())
            .format("z");
        if (response[i].status === "inProgress" || response[i].status === "upcoming") {
          let CalendarEvent : ICalendarEvent = {} as ICalendarEvent;
          let alarms:any = [];
          alarms.push({
            action: 'display',
            trigger: {hours:0,minutes:15,before:true},
          })
          CalendarEvent.alarms=alarms;
            CalendarEvent.start =[parseInt(momentDate.format("YYYY")),parseInt(momentDate.format("MM")), parseInt(momentDate.format("DD")), parseInt(momentDate.format("HH")), parseInt(momentDate.format("mm"))];
            momentDate= Moment(Moment.unix(parseInt(response[i].endTime)));
            CalendarEvent.end =[parseInt(momentEndDate.format("YYYY")),parseInt(momentEndDate.format("MM")), parseInt(momentEndDate.format("DD")), parseInt(momentEndDate.format("HH")), parseInt(momentEndDate.format("mm"))];
            CalendarEvent.title = "Session with teacher " + coachname;
            CalendarEvent.uid =String(sessionId);
            if (addCalendarEvents.length<=0 || addCalendarEvents.filter(unique=> unique.uid===sessionId).length<=0) 
            addCalendarEvents.push(CalendarEvent);
          sessionNumber = sessionNumber + 1;
          rescheduleDiffHours = (parseInt(response[i].startTime) - Moment().unix()) / 60;
          rescheduleSeatPoolHours = Number(process.env.REACT_APP_RESCHEDULING_NOTICE_HOUR) * 60;
          rescheduleLimit = Number(process.env.REACT_APP_RESCHEDULING_LIMIT);
          sessionRescheduleCalculation = Math.ceil((rescheduleLimit / 100) * response.length);
          if (rescheduleDiffHours > rescheduleSeatPoolHours) {
            allowReschedule = true;
          } else if (cancelledSessionCount < sessionRescheduleCalculation) {
            allowCancellation = true;
          }

          UpcomingArray[ClassCounter] = {} as IUpcomingData;
          if (response[i].status === "inProgress") {
            if (
              parseInt(response[i].startTime) <= Moment().unix() &&
              parseInt(response[i].endTime) >= Moment().unix()
            ) {
              UpcomingArray[ClassCounter].upcomingTimeData = parseInt(response[i].startTime);
              UpcomingArray[ClassCounter].upcomingClassRoomLink = response[i].students[j].classroomLink;
              ClassCounter = ClassCounter + 1;
            }
          } else {
            if (parseInt(response[i].endTime) >= Moment().unix()) {
              UpcomingArray[ClassCounter] = {} as IUpcomingData;
              UpcomingArray[ClassCounter].upcomingTimeData = parseInt(response[i].startTime);
              UpcomingArray[ClassCounter].upcomingClassRoomLink = response[i].students[j].classroomLink;
              ClassCounter = ClassCounter + 1;
            }
          }
          if ((UpcomingArray[0].upcomingTimeData >= parseInt(response[i].startTime) && UpcomingArray[0].upcomingTimeData <= response[i].endTime) || sessionStorage.getItem("isDemoUser")) {
            RecentUpcomingData.SessionId = sessionId;
            RecentUpcomingData.CoachName = coachname;
            RecentUpcomingData.startTimeUnix = parseInt(response[i].startTime);
            RecentUpcomingData.Session_GetstartDate = session_GetstartDate;
            RecentUpcomingData.StartTime = startTime;
            RecentUpcomingData.DurationMins = durationMins.toString();
            RecentUpcomingData.IconType =
              !allowReschedule && !allowCancellation ? "N/A" : allowReschedule ? "Reschedule" : "Cancel";
            for (let sessionNum = 1; sessionNum < durationMins / singleDuration; sessionNum++) {
              sessionNumber = sessionNumber + 1;
              RecentUpcomingData.SessionNumber = RecentUpcomingData.SessionNumber + " & " + sessionNumber;
            }
            RecentUpcomingData.classroomLink = response[i].students[j].classroomLink;
          } else {
            if (response[i].status === "upcoming" || response[i].status === "inProgress") {
              upcomingSessionsData[UpcomingCounter] = {} as ILearnerSessions;
              upcomingSessionsData[0].FeedbackData = {} as IFeedbackData[];
              upcomingSessionsData[0].FeedbackData = feebackDetails;
              upcomingSessionsData[UpcomingCounter].CoachName = coachname;
              upcomingSessionsData[UpcomingCounter].SessionId = sessionId;
              upcomingSessionsData[UpcomingCounter].Session_GetstartDate = session_GetstartDate;
              upcomingSessionsData[UpcomingCounter].StartTime = startTime;
              upcomingSessionsData[UpcomingCounter].DurationMins = durationMins.toString();
              upcomingSessionsData[UpcomingCounter].SessionNumber = String(sessionNumber);
              upcomingSessionsData[UpcomingCounter].startTimeUnix = parseInt(response[i].startTime);
              for (let sessionNum = 1; sessionNum < durationMins / singleDuration; sessionNum++) {
                sessionNumber = sessionNumber + 1;
                upcomingSessionsData[UpcomingCounter].SessionNumber = upcomingSessionsData[UpcomingCounter].SessionNumber + " & " + sessionNumber;
              }
              upcomingSessionsData[UpcomingCounter].IconType =
                !allowReschedule && !allowCancellation ? "N/A" : allowReschedule ? "Reschedule" : "Cancel";
              UpcomingCounter = UpcomingCounter + 1;
            }
          }
        } else if (
          studentsupdated === "finished" ||
          studentsupdated === "lost" ||
          studentsupdated === "canceled"
        ) {
          if(calendarEvents.filter(events=> events.uid=== String(sessionId)).length>0)
          {
            addCalendarEvents = addCalendarEvents.filter(events=> events.uid!==String(sessionId));
          }
          pastSessionsData[PastCounter] = {} as ILearnerSessions;
          pastSessionsData[0].FeedbackData = {} as IFeedbackData[];
          if (studentsupdated === "finished" || studentsupdated === "lost") {
            sessionNumber = sessionNumber + 1;
            pastSessionsData[PastCounter].SessionNumber = String(sessionNumber);
            for (let sessionNum = 1; sessionNum < durationMins / singleDuration; sessionNum++) {
              sessionNumber = sessionNumber + 1;
              pastSessionsData[PastCounter].SessionNumber = pastSessionsData[PastCounter].SessionNumber + " & " + sessionNumber;
            }
          }
          pastSessionsData[0].FeedbackData = feebackDetails;
          pastSessionsData[PastCounter].CoachName = coachname;
          pastSessionsData[PastCounter].SessionId = sessionId;
          pastSessionsData[PastCounter].Session_GetstartDate = session_GetstartDate;
          pastSessionsData[PastCounter].StartTime = startTime;
          pastSessionsData[PastCounter].startTimeUnix = parseInt(response[i].startTime);
          pastSessionsData[PastCounter].DurationMins = durationMins.toString();
          pastSessionsData[PastCounter].studentStatus = studentsupdated;
          if (studentsupdated === "finished") {
            pastSessionsData[PastCounter].IconType = "finished";
            FinishedSessionsData[finishedCounter] = {} as ILearnerSessions;
            FinishedSessionsData[0].FeedbackData = {} as IFeedbackData[];
            FinishedSessionsData[0].FeedbackData = feebackDetails;
            FinishedSessionsData[finishedCounter].IconType = "finished";
            FinishedSessionsData[finishedCounter].studentStatus = "finished";
            FinishedSessionsData[finishedCounter].CoachName = coachname;
            FinishedSessionsData[finishedCounter].SessionId = sessionId;
            FinishedSessionsData[finishedCounter].Session_GetstartDate = session_GetstartDate;
            FinishedSessionsData[finishedCounter].StartTime = startTime;
            FinishedSessionsData[finishedCounter].DurationMins = durationMins.toString();
            FinishedSessionsData[finishedCounter].SessionNumber = String(sessionNumber);
            FinishedSessionsData[finishedCounter].startTimeUnix = parseInt(response[i].startTime);
            FinishedSessionsData[finishedCounter].SessionId = sessionId;
            FinishedSessionsData[finishedCounter].SessionLocation= response[i].students[j].classroomLink
            finishedCounter = finishedCounter + 1;
            pastSessionsData[PastCounter].SessionLocation = response[i].students[j].classroomLink;
          } else if (studentsupdated === "lost") {
            pastSessionsData[PastCounter].IconType = "lost";
          } else if (studentsupdated === "canceled") {
            pastSessionsData[PastCounter].IconType = "canceled";
          }
          if (studentsupdated === "lost" || studentsupdated === "canceled") {
            missedSessionData[missedCounter] = {} as ILearnerSessions;
            missedSessionData[missedCounter].IconType = response[i].status;
            missedSessionData[missedCounter].CoachName = coachname;
            missedSessionData[missedCounter].SessionId = sessionId;
            missedSessionData[missedCounter].Session_GetstartDate = session_GetstartDate;
            missedSessionData[missedCounter].StartTime = startTime;
            missedSessionData[missedCounter].DurationMins = durationMins.toString();
            missedSessionData[missedCounter].SessionNumber = String(sessionNumber);
            missedSessionData[missedCounter].startTimeUnix = parseInt(response[i].startTime);
            missedSessionData[missedCounter].SessionId = sessionId;
            missedSessionData[missedCounter].studentStatus = studentsupdated
            missedCounter++;
        }
          PastCounter = PastCounter + 1;
        }
      }
    }
    setCalenderEvents(addCalendarEvents);
    SetRecentData(RecentUpcomingData);
    SetUpcomingData(upcomingSessionsData);
    setCompletedData(FinishedSessionsData);
    setMissedData(missedSessionData);
    if (PastCounter > 0 && finishedCounter > 0) {
      const feedbackParsed = allInfo.getLearnerFeedback.data?.getLearnerFeedback && JSON.parse(allInfo.getLearnerFeedback.data?.getLearnerFeedback);
      for(let finished=1; finished<=finishedCounter; finished++)
      {
     
         if(feedbackParsed.length && feedbackParsed.filter((data: { session_id: any; })=>Number(data.session_id)===Number(FinishedSessionsData[finishedCounter - finished].SessionId)).length>0)
        {
          continue;
        }
        else
        {
          if (sessionStorage.getItem("RemindLater") !== "true") {
            const SessionDetails: ISessionRating = {} as ISessionRating;
            SessionDetails.IsReadOnly = false;
            SessionDetails.Content = false;
            SessionDetails.Technology = false;
            SessionDetails.Teacher = false;
            SessionDetails.SessionDate = FinishedSessionsData[finishedCounter - finished].Session_GetstartDate || "";
            SessionDetails.SessionDuration = FinishedSessionsData[finishedCounter - finished].DurationMins || "";
            SessionDetails.SessionTime = FinishedSessionsData[finishedCounter - finished].StartTime || "";
            SessionDetails.Status = FinishedSessionsData[finishedCounter - finished].IconType || "";
            SessionDetails.CoachName = FinishedSessionsData[finishedCounter - finished].CoachName || "";
            SessionDetails.SessionID = FinishedSessionsData[finishedCounter - finished].SessionId;
            setSessionRating(SessionDetails);
            setRatingPopup(true);
          }
          break;
        }
      }
    }
    const allData: ILearnerSessions[] = { ...pastSessionsData };
    for (let i = PastCounter, j = 0; i < PastCounter + UpcomingCounter && j <= UpcomingCounter; i++, j++) {
      allData[i] = upcomingSessionsData[j];
    }
    let sortedArray: ILearnerSessions[] = Object.values(allData).slice()
      .sort((a: any, b: any) => a.startTimeUnix - b.startTimeUnix);
    SetAllSessionData(sortedArray);
    setLoaderFlag(false);
  };
     
  useEffect(() => {
    const checkJoinNowButtonEnable = setInterval(() => {
      joinNowCheck(RecentData.startTimeUnix, RecentData.classroomLink);
    }, 1000);
    return () => clearInterval(checkJoinNowButtonEnable);
  }, [RecentData]);
  return typeof (status) === 'undefined' || status === null || status === 0 ? (
    <React.Fragment>
      <LatestUpcomingBlock
        prodName={productName}
        RecentData={RecentData}
        isJoinNowEnabled={isJoinNowEnabled}
        classRoomLink={currentSessionLink}
        isCancelVisible={isCancelVisible}
        setJoinNow={setJoinNow}
        calendarEvents = {calendarEvents}
        handleCalendarClick = {handleCalendarClick}
      ></LatestUpcomingBlock>
      <div data-testid="StaticInfoID" className="StaticInfo">
        {/* <div className="policy">
          <a href="#"><CheckIcon />{translate("class_policy")}</a>
        </div> */}
        {/* <div className="policy">
          <a href="#"><DescriptionIcon />{translate("Instrucions")}</a>
        </div>
        <div className="policy">
          <a href="#"><HelpIcon />{translate("Faq")}</a>
        </div> */}
        <div className="InfoLabel">
          <label>
            <b>{translate("SessionRating_sessionDuration")}:</b> {duration} {translate("myschedule_sessionDuraion_minutes")}
          </label>
          <label className="Communication">
            <b>{translate("myschedule_sessionDetails_communication")}:</b> {comMode}
          </label>
        </div>
        <Select className="session-filter" id="SessionFilterId" value={records} onChange={handeRecords}>
          <MenuItem value={"All sessions"}>{translate("myschedule_sessionDetails_allSessions")}</MenuItem>
          <MenuItem value={"Upcoming sessions"}>{translate("myschedule_sessionDetails_upcomingSessions")}</MenuItem>
          <MenuItem value={"Completed sessions"}>{translate("myschedule_sessionDetails_completedSessions")}</MenuItem>
          <MenuItem value={"Missed sessions"}>{translate("myschedule_sessionDetails_missedSessions")}</MenuItem>
        </Select>
      </div>
      {records === "All sessions" && (
        <AllSessionBlock prodName={productName} UpcomingData={AllSessionData} records={records} handleDispatch={handleDispatch}></AllSessionBlock>
      )}
      {records === "Upcoming sessions" && (
        <AllSessionBlock
          prodName={productName}
          UpcomingData={UpcomingData}
          records={records}
          handleDispatch={handleDispatch}
        ></AllSessionBlock>
      )}
      {records === "Completed sessions" && (
        <AllSessionBlock
          prodName={productName}
          UpcomingData={CompletedData}
          records={records}
          handleDispatch={handleDispatch}
        ></AllSessionBlock>
      )}
      {records === "Missed sessions" && (
        <AllSessionBlock
          prodName={productName}
          UpcomingData={missedData}
          records={records}
          handleDispatch={handleDispatch}
        ></AllSessionBlock>
      )}
      {ratingPopup && (
        <SessionRatingPopup
          sessionRating={sessionRatingProps}
          setRatingPopup={setRatingPopup}
          StarRating={sessionRatingProps.Rating}
        ></SessionRatingPopup>
      )}
      <Loader showLoader={loaderFlag} />
      <Toaster
        open={toastOptions.toastOpen}
        severity={toastOptions.toastSeverity}
        toasterClosed={toasterHandle}
        messageKey={toastOptions.toastMessageKey}
      />
    </React.Fragment>
  ) : (< React.Fragment > <ErrorPage status={status} />
    <Loader showLoader={loaderFlag} />
    <Toaster
      open={toastOptions.toastOpen}
      severity={toastOptions.toastSeverity}
      toasterClosed={toasterHandle}
      messageKey={toastOptions.toastMessageKey}
    />
  </React.Fragment >);
};

export default PastAndUpcomingSessions;
